export default __webpack_public_path__ + "static/Loft2-scaled-624555ab7d69e7f3546e89c63e84190d.jpg";